import { ActiveButton, InactiveButton } from 'components/StatusButtons/styles'

interface StatusButtonsProps {
  handleChangeActiveStatus: () => void
  handleChangeInactiveStatus: () => void
  currentChangeStatus: number | undefined
  loading?: boolean
}

const StatusButtons: React.FC<StatusButtonsProps> = ({
  handleChangeActiveStatus,
  handleChangeInactiveStatus,
  currentChangeStatus,
  loading
}) => {
  return (
    <>
      <ActiveButton data-testid={`activebutton`}
        onClick={handleChangeActiveStatus}
        className={`${currentChangeStatus === 1 ? 'text-active border-active ' : ''}${loading ? 'animate-bounce repeat-infinite' : ''}`}
      >
        Ativo
      </ActiveButton>

      <InactiveButton data-testid={`inactivebutton`}
        onClick={handleChangeInactiveStatus}
        className={`${currentChangeStatus === 2 ? 'text-orange border-orange ' : ''}${loading ? 'animate-bounce repeat-infinite' : ''}`}
      >
        Inativo
      </InactiveButton>
    </>
  )
}

export default StatusButtons
